import type { ChakraProps } from "@chakra-ui/react";

export const menuButtonStyles: ChakraProps["sx"] = {
  position: "relative",
  span: {
    color: "inherit",
  },
  ":hover": {
    span: {
      color: "transparent",
      svg: { color: "primary.500" },
      _after: { fontWeight: "medium", color: "primary.500", opacity: 1 },
    },
  },
};

export const accordionButtonStyles: ChakraProps["sx"] = {
  svg: { color: "primary.900" },
  _expanded: { svg: { transform: "rotate(180deg)" } },
};
